<template>
  <div class="w-100">
      <Loader class="w-100" :loading="loading">
          <div class=" p-list-representation-wrapper align-items-start">
              <div  class="w-100p-list-representation-content row mr-auto ml-auto align-items-start">
                <div class="w-100" >
                  <appHeader></appHeader>
                </div>

                <div class=" row p-list-representation-data w-100">
                  <contentList
                  @searchData="searchData"

                  :page="page"
                  :form-data="formData"
                  ></contentList>
                </div>

              </div>

          </div>

        <tableContent
         :page="page"
         :all-enums="allEnums"
         :table-data="tableData"
          @paganationChangePage="paganationChangePage"
          @btnShowModalWallet="btnShowModalWallet"
        ></tableContent>

        <modalWalletPlayer
          :active.sync="showModalWalletPlayer"
          :single-value-modal-player="singleValueModalPlayer"
          />


      </Loader>
  </div>
</template>

<script>
import contentList from '../components/walletPlayer/contentList';
import appHeader from '../components/includes/AppHeader';
import tableContent from '../components/walletPlayer/tableContent';
import addCama from '../modules/addCama.js'
import settings from '../modules/settings';
import modalWalletPlayer from '../components/walletPlayer/modalWalletPlayer';



export default {
  name: "walletPlayer",
  components: {
    contentList,
    appHeader,
    tableContent,
    modalWalletPlayer,
  },

  props: {

  },

  data() {
    return {
      loading                                 : true,
      page                                    : 0,
      checkEmptyCity                          : 'default',
      tableData                               : [],
      page                                    : 1,
      checkRunFirstGetDefaultProvinceAndCity  : 'initialLoaded',
      statusRunPaganation                     : true,
      checkPermissionMultiUpdateTableData : true,
      loadingTransactionForm              : false,
      formData                            : {
        per_page   : 10,
        page       : 1,
        player_id  : -1,
        mobile     : '',
        nameFamily : '',
      },
      allEnums : {},
      showModalWalletPlayer  : false,
      singleValueModalPlayer : {},



    }
  },

  watch: {

  },

  created() {

  },


  mounted() {
    const getParams = this.$route.params;
    const getQuery  = this.$route.query;

    if (typeof(getParams.id) != 'undefined') {
      this.formData.player_id    = getParams.id;
      this.formData.nameFamily   = getQuery.name + getQuery.family;
      this.formData.mobile       = getQuery.mobile;
    }

    this.getTableData();
  },


  methods: {


    updateTableDataAndProvinceAndCity(page){
      this.loading                                 = true;
      this.formData.page                           = page;
      this.checkRunFirstGetDefaultProvinceAndCity  = 'preventGetProvinceAndCity';
      this.getTableData();
    },

    paganationChangePage(page){


      if (!this.checkPermissionMultiUpdateTableData) {
        // در صورتی که کاربر در صفحه دو تیبل باشد  و عدد صفحه تیبل تغییر کند //
        // دو در خواست اجرا می شود برای جلوگیری از دو در خواست همزمان //
        // کد زیر نوشته شد //
        if (page != 1) {
          this.checkPermissionMultiUpdateTableData = true;
        }
      }


      if (this.checkPermissionMultiUpdateTableData) {
        this.page = page;
        this.updateTableDataAndProvinceAndCity(page);
      }
      else {
        // اجازه اجرا شدن لاجیک کال بک پجینیشن //
        this.checkPermissionMultiUpdateTableData = true;
      }

    },

    searchData(data){
      for (let key in data) {
        this.formData[key] = data[key];
      }

      this.page           = 1;
      this.checkPermissionMultiUpdateTableData     = false;

      this.updateTableDataAndProvinceAndCity(this.page);
    },

    getTableData(){
      this.$store
      .dispatch('walletPlayer/getTableData', {
        data : {
          ...this.formData,
        }
      })
      .then((res)=>{
        this.loading                               = false;
        this.convertTimeStampInToJalali(res.tableData.data);
        this.tableData    = res.tableData.data;
      })
    },

    convertTimeStampInToJalali(tableData){
      tableData.map((t,i)=>{
        const resultAddCama                 = addCama(t.amount);
        t.addCamaPrice                      = resultAddCama;
        const resultConvert                 = this.$moment.unix(t.created_at).format("jYYYY/jMM/jDD HH:mm:ss").split(' ');
        t.dateConvertedJali                 =  resultConvert[0];
        t.timeConvertedJali                 =  resultConvert[1];
      })
    },

    btnShowModalWallet(data){
      this.singleValueModalPlayer = data;
      this.showModalWalletPlayer  = true;
    },






  }


}
</script>
